module.exports = __webpack_public_path__ + "fonts/Montserrat.ee653992.ttf";